'use strict';
import * as $i_$0040ui5$002fwebcomponents$002dfiori$002fdist$002fSideNavigationItem$002ejs from "@ui5/webcomponents-fiori/dist/SideNavigationItem.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  this.Ip = null;
  this.Iq = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-side-navigation-item");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$.prototype = $p;
$p.uE = (function() {
  if ((!this.Iq)) {
    this.Ip = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "text", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.Iq = true;
  }
  return this.Ip;
});
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002dfiori$002fdist$002fSideNavigationItem$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$, "io.github.nguyenyou.ui5.webcomponents.laminar.SideNavigationItem$", ({
  jL: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigationItem$ };
